import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CookieHelperService } from '../services/cookie-helper.service';

@Injectable()
export class OfferGuard implements CanActivate {

    constructor(private cookieService: CookieHelperService, private router: Router) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const prequalResponseCookie = this.cookieService._getCookie('prequalResponse');
        if (prequalResponseCookie === undefined || prequalResponseCookie === null || (
            prequalResponseCookie.data != null &&
            !prequalResponseCookie.data.isPrequal
        )) {
            this.router.navigate(['auto-loans/prequalify'], {replaceUrl: true});
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/offer.guard.ts